import React from 'react';
import InlineText from '../admin/newContentManagement/InlineText';

interface FundUpdateTitleFieldProps {
  title: string | null | undefined;
  onChange: (title: string) => void;
}

/** Click-to-edit title for a fund update, shown beside its date. Optional — blank shows a hint. */
export default function FundUpdateTitleField({ title, onChange }: FundUpdateTitleFieldProps) {
  return (
    <InlineText
      value={title ?? ''}
      onChange={onChange}
      placeholder="Add a title"
      ariaLabel="Update title"
      sx={{ fontWeight: 600, fontSize: '0.95rem' }}
    />
  );
}
